import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=2ad390c5"
import script from "./Sports.vue?vue&type=script&lang=js"
export * from "./Sports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports